import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import FilterListIcon from '@mui/icons-material/FilterList';
import InfoIcon from "@mui/icons-material/Info";
import IconButton from "@mui/material/IconButton";

import {getFilterValueThumbnailAndStyles} from "../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions";
import {getFeatureGroupIconStyles, getFeatureGroupIconURL} from "../../bvComponent/core/assets";
import {wizardGroupInterface, wizardSelectedValueInterface} from "../../../interfaces/wizardItemInterface";
import {featureGroupInterface} from "../../../interfaces/featureInterface";


const MaterialsWizardFooterStepThumbnail = (props) => {

  const {wizardGroup, wizardSelectedValue, allFilterGroups, isMobile, activeTheme, featureGroup} = props;

  let selectedFilter = wizardSelectedValue ? wizardSelectedValue.selectedFilter : null;

  // const notSelected = !wizardSelectedValue || !(Object.keys(wizardSelectedValue).length)
  //   || (!selectedFeature && !selectedFilter);
  //
  // if (notSelected) {
  //   const featureGroup = wizardGroup ? getFeatureGroupFromWizardGroup(wizardGroup) : null;
  //   return <div className="selection-footer-list__item-icon"
  //               style={featureGroup ? getFeatureGroupIconStyles(featureGroup, activeTheme) : null}>
  //   </div>
  // }

  if (wizardGroup && selectedFilter && wizardGroup.nodeType === "filter") {
    if (isMobile) {
      return (
        <div className="selection-footer-list__item-icon">
          <IconButton className={"look-icon look-icon--super-tiny"}>
            <FilterListIcon/>
          </IconButton>
        </div>
      )
    }
    const filterGroup = allFilterGroups.find(group => group.id === selectedFilter.filterGroup_id);
    const {styles} = getFilterValueThumbnailAndStyles(selectedFilter, filterGroup || {});
    return <div className="selection-footer-list__item-icon"><div className="lw-step__thumbnail" style={styles}/></div>
  } else if (wizardGroup) {
    return (
      <div className="selection-footer-list__item-icon" style={
        wizardGroup && (wizardGroup.wizardGroupIcon || wizardGroup.scopeImageUrl)
            ? getFeatureGroupIconStyles({customImageUrl: getFeatureGroupIconURL(wizardGroup.wizardGroupIcon || wizardGroup.scopeImageUrl)}, activeTheme)
            : featureGroup ? getFeatureGroupIconStyles(featureGroup, activeTheme) : null
      }/>
    )
  }

  // just in case
  return (
    <div className="selection-footer-list__item-icon">
      {isMobile
        ? <IconButton className={"look-icon look-icon--super-tiny"}><InfoIcon/></IconButton>
        : <div className="selection-footer-list__item-icon"/>}
    </div>
  )

};

MaterialsWizardFooterStepThumbnail.propTypes = {
  wizardGroup: PropTypes.shape(wizardGroupInterface),
  featureGroup: PropTypes.shape(featureGroupInterface),
  wizardSelectedValue: PropTypes.shape(wizardSelectedValueInterface),
}

const mapStateToProps = (store) => {
  const {filterGroups} = store.filterState;
  const {activeTheme} = store.serverState;

  return {
    allFilterGroups: filterGroups,
    activeTheme,
  };
};

export default connect(mapStateToProps)(MaterialsWizardFooterStepThumbnail)
